const jq = require('jquery');

if (typeof jQuery !== 'undefined')
    jQuery.Deferred = jQuery.Deferred || jq.Deferred;